export const CARD_BASE_CLASS = 'item'
